import McpProviders from './Pages/McpProviders';
import CreateMcpProvider from './Pages/CreateMcpProvider';
import EditMcpProvider from './Pages/EditMcpProvider';
import CreateMcpSkill from './Pages/CreateMcpSkill';
import EditMcpSkill from './Pages/EditMcpSkill';

// Temporary bypass for MCP route visibility while permissions are being wired.
const canAccessAll = () => true;

const routes = [
  {
    path: '/mcp/providers',
    component: McpProviders,
    name: 'MCP Providers',
    canAccess: canAccessAll,
    exact: true
  },
  {
    path: '/mcp/providers/create',
    component: CreateMcpProvider,
    name: 'New MCP Provider',
    canAccess: canAccessAll,
    exact: true
  },
  {
    path: '/mcp/providers/:id',
    component: EditMcpProvider,
    name: 'Edit MCP Provider',
    canAccess: canAccessAll,
    exact: true
  },
  {
    path: '/mcp/providers/:providerId/skills/create',
    component: CreateMcpSkill,
    name: 'Add MCP Skill',
    canAccess: canAccessAll,
    exact: true
  },
  {
    path: '/mcp/skills/:id',
    component: EditMcpSkill,
    name: 'Edit MCP Skill',
    canAccess: canAccessAll,
    exact: true
  }
];

export default routes;
